
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexwbV4FnvKnyFRYgNWy2ljESvDLedy9VL28aPQhLQ75zsMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/index.vue?macro=true";
import { default as account3HufUZFYdCCy3y1_InwrtoWh727HuMTu7HOGCTubAD8Meta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/account-settings/common-layer/pages/account.vue?macro=true";
import { default as indexrSwjwFmUsdCHgq7ejOBbgACeD4cTKyTLEWhF6MPkjMUMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/auth/index.vue?macro=true";
import { default as loginBipPEegN8gfngljKdMa_451_zrD7mzapKN4YoHIV5dfHMMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/auth/login.vue?macro=true";
import { default as signup_50uaXaQ9efyfsK_45TzxZxbBq4RyDjWHWJ2OKOsPbkbwMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/auth/signup.vue?macro=true";
import { default as _91_46_46_46notFound_93tPtpZJIxjMC7MTkxpSINtfLtarklV54hiyqVtRquKeUMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/[...notFound].vue?macro=true";
import { default as indexvvmsXhfanLDNW031VyxYyFRbFMmh0NZ4Tn3GWrCdckkMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/courses/index.vue?macro=true";
import { default as searchU9a9DSKELD4AC2BEi5jWWveJpmxViXXk09N2UcC3Vy0Meta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/courses/routing-layer/pages/courses/search.vue?macro=true";
import { default as indexxyAemPq0hMqoJNfLcM_45VnqkqJySlU8VAO376lMn46jIMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/invoices/index.vue?macro=true";
import { default as leadxnbs9cWCdRZ_45ZJqWZRrHm0WlNctuFEQZn5UXm0uzxMAMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/affiliates/lead.vue?macro=true";
import { default as indexTiaoYQDUFcTPTiNEQUBdd1kbRErcxAKdEMdBG_d4wVUMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/contracts/index.vue?macro=true";
import { default as indexxI9cyOV73JAUVdTKAnS4BLsbKR83lc6LXoobvHd6tuwMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/dashboard/index.vue?macro=true";
import { default as indexoV_45zOIs4JWyB9ILZOZbF5Hl_XKqURTZRPw_ebgbhxK8Meta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/documents/index.vue?macro=true";
import { default as indexsNOeTo0MvAYfNDMmeRWlM3WBycg_T4ZLC44sXU3Y2tgMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/estimates/index.vue?macro=true";
import { default as index8_45sXo8kiVYwmbQ9Gv0Of7B_cpMN0noYitwnBgfang8oMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/affiliates/index.vue?macro=true";
import { default as discoverDvsO2F5MjFH_45RjezqaxwA0X1r7Rwbv71Pzw3dtWGQowMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/courses/discover.vue?macro=true";
import { default as indexI1ffg9dfzesxTLGSCJm6W8aXxdz_456Q3wHgy3EdtpAlAMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/communities/index.vue?macro=true";
import { default as index7_ZfN90u9_fFDY1sSG6h_458cvFu5Scz5DspPNExTgoScMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/appointments/index.vue?macro=true";
import { default as my_45coursesV_JmKpkERisrTQxad9XpN0pb2rn3mZpZe8OXT3WTT8MMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/courses/my-courses.vue?macro=true";
import { default as my_45libraryx3OOe6GLkKnhwQWP59h8y2n6npIgYr1cTahOevFAm04Meta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/courses/routing-layer/pages/courses/my-library.vue?macro=true";
import { default as indexPpRiJpet3BurjVTfzHgIuLJ5uNGTtZkSsmhCpuHnT3EMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/shared-files/index.vue?macro=true";
import { default as campaigngdFhhIBQoDRs9JBEIKS2K7hRGam8_mhFYyujJ_evGdUMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/affiliates/campaign.vue?macro=true";
import { default as reset_45password5y14axdvWv_dplDeVyOGaZ_rbiVm6_xtX23dS4A4WP0Meta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/auth/reset-password.vue?macro=true";
import { default as _91productId_93u35MLwMZSrD8Cu_45mFLZt_L94iAVANvZ7tLjbrFIZ3PIMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/courses/routing-layer/pages/courses/[productId].vue?macro=true";
import { default as forgot_45passwordtIMvS_45KvqX4QzB1xXRz6WOw7G9dM172GInQcEQ_455trAMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/auth/forgot-password.vue?macro=true";
import { default as login_45with_45codeGKBcsdjY4zWLoo1LcdJhxDN3259fmpJFfByFjzlk_uQMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/auth/login-with-code.vue?macro=true";
import { default as discovervakGMkOkSHaZQpMu5PYydfIlAzrDjY2wFW_sTAs3aIEMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/communities/discover.vue?macro=true";
import { default as commissionff57G1xL7vJBnLB4NRRzF0B1iAb_457uzyU7ON_45KBFyGQMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/affiliates/commission.vue?macro=true";
import { default as expired_45password9_45CEtO70kh1zxmtCac3FigMGcaNh6zb4cj9yV5bAYa4Meta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/auth/expired-password.vue?macro=true";
import { default as indexYzyzzi1w9qvZ3_w0t7Ggolq33eZzmbSPtXjqAymGyPIMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/affiliates/media/index.vue?macro=true";
import { default as sub_45affiliatetU3xK5g4Id8lM603d7tnZ_hfNQHdHMlFsFDU6ijck_IMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/affiliates/sub-affiliate.vue?macro=true";
import { default as payout_45methodsdndl_J0jnwaMFmdP0mZppoIMJWtxP5YO5gEDd8fch1YMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/affiliates/payout-methods.vue?macro=true";
import { default as profile_45confirmation4m_krel8AaTUjKBFZdYMMf_QfItcUNv56bsngZBYHXoMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/auth/profile-confirmation.vue?macro=true";
import { default as my_45communitiesr7e0Tb6wMkNgkWVOacZ0tuW1HtRPv6sIuUrMsP8tBb0Meta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/communities/my-communities.vue?macro=true";
import { default as not_45foundvl1MVwiEkRjSeExi7WWjz8VHkPMKJduxf6TWSaNIR4MMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/not-found.vue?macro=true";
import { default as indexaQWfUXk1awq_9AYxeD7K49V27LcDIW8ccws2tjJd1rIMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/conversations/index.vue?macro=true";
import { default as _91bundleOfferId_93O8PQ8OWqz08djotsUd0uMtcjD4ykZNnhl79wgqm27Y0Meta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/courses/bundles/[bundleOfferId].vue?macro=true";
import { default as _91productId_93TPFyk8N4jdRZjTI6CwI4ohoao7ZoHMExep_45u4rZHOPQMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/courses/routing-layer/pages/courses/products/new/[productId].vue?macro=true";
import { default as _91folderId_93uhOavHrWnxM1T0tFfzIOa_45CLFlrznzqq56u8yzp_45wmkMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/affiliates/media/folder/[folderId].vue?macro=true";
import { default as indexKYH51dinf_45mDCIEQc8KWeefcdEqtsnO_45_45pzut1T90rcMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/users/[userSlug]/index.vue?macro=true";
import { default as indexE64TAFFH_45kPa84I7bVgUn8O5yaa6Fxxa3eQs0JQLhIEMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/courses/routing-layer/pages/courses/products/[productId]/index.vue?macro=true";
import { default as _91postId_93seI0_pf4xTKQmgzX4yesH0VGXc97rqHBC4vIJeiDWb0Meta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/home/posts/[postId].vue?macro=true";
import { default as home2VHrIbY_yhHS018exrqpuaurDfMeGJaNwvmJ96mrlTQMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/home.vue?macro=true";
import { default as aboutgxoGMm4FGzqRVJczc1fx29mDUaFAaTETxT7HNxT3DCAMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/about.vue?macro=true";
import { default as indexrzzRMGJDAe2ZRHKXPABO2NsES4_4573P6Ryjejs45aABgMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/index.vue?macro=true";
import { default as affiliatesIndexPage_46middlewareomkoWXm7R_W_45SkhNosrBk1QAzfnM0kr_45WA_iUUu7XqwMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/affiliates/affiliatesIndexPage.middleware.ts?macro=true";
import { default as communitiesSblnqHPFKvRZjxK8DqKRLKt_YvlGgNAe_45zsSJNQ0LrUMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/users/[userSlug]/communities.vue?macro=true";
import { default as _91conversationId_93ol3zaKSLqWkCdSTec0GAaZZUmBmG14s7z92vIKYnrakMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/conversations/[conversationId].vue?macro=true";
import { default as leaderboardSJiSW5feL7FvqZeQ7ihc4rjOkFo0Ymv1i4cdbLZrmvEMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/leaderboard.vue?macro=true";
import { default as contributionsACrgBfQ49pWdeU_Xh12X2lSEPW5ZgE2kDlDc0ighoHoMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/users/[userSlug]/contributions.vue?macro=true";
import { default as live_45sessionsdPG82oHl2HCovO33pB7pLTWGJLnXSzPAgrX3CXjiivsMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/courses/routing-layer/pages/courses/products/[productId]/live-sessions.vue?macro=true";
import { default as indexy9aEAnIxfkBm3kXMZC48C8oKkAqcc1E21YyEOlDe8z4Meta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/events/index.vue?macro=true";
import { default as _91postId_93D2XYPbNGtVcvDMue_45BEGHVaE1zrY7AnG7jSIko6u1hoMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/users/[userSlug]/posts/[postId].vue?macro=true";
import { default as _91_46_46_46catchAll_93fACdXHgsApX1eM8KUj1aF_4N0MJe2OsOLziPYnbYehAMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/[...catchAll].vue?macro=true";
import { default as conversationsFH3LUtF5A_45ywkmqT57gcMpvjyiyqB93q7SlFiZ_bB0kMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/conversations.vue?macro=true";
import { default as indexIBHs_9q3VRpfpbMz3NjKKdZGseQqx_450rwb8ArmAtAdAMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/members/index.vue?macro=true";
import { default as purchase_45courseVvcOOFhrO7LQlVzUhUbT2X7MWyA1cMZXriZsC2ZS8SoMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/courses/routing-layer/pages/courses/products/[productId]/purchase-course.vue?macro=true";
import { default as index4MWqiAvCaWRE5fZBduDawDM4ZIpYay9Jcy8hNNiAbwQMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/learning/index.vue?macro=true";
import { default as indexkWa3GOh33J_5vxZhQpZrphHNHBER0w_45c_45A8U6HOlL6EMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/index.vue?macro=true";
import { default as detailscKT9p2PBxpE_5cQHeTIp26vBofL5nhsGWxcVzJaMr9wMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/details.vue?macro=true";
import { default as brandingFJhOl97O9T3c1B0_RRuk1AZIZtNYQ5P5b6LIXo0s4XoMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/branding.vue?macro=true";
import { default as discoveryvH_1fE2SFBjyb5FmNixzO_45N_w92kAGDYn_VzivQz4EMMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/discovery.vue?macro=true";
import { default as appearancegddrWvWP7HTdLEiClbAZN_45XQ9jOrZjTLZDfod93jT_45kMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/appearance.vue?macro=true";
import { default as newsletterpXgw_Jqrpzw_RsZZoQvbOU65u_aT146jWmQzYBnVStEMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/newsletter.vue?macro=true";
import { default as _91postId_93ExW0TNM8vBx5NBoWIEQJWUnu9ZwLXBSfF7z5N3Zs6f0Meta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/channels/[channelSlug]/posts/[postId].vue?macro=true";
import { default as _91channelSlug_93gM6CK4vY0aHyNA4YQdieZkXaZL_45PJFGY18CkYbFxSbEMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/channels/[channelSlug].vue?macro=true";
import { default as subscriptionszLSQyvoRgth86tmtTCSp1v01sO5Vo5pbb91c74t3IekMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/subscriptions.vue?macro=true";
import { default as community_45tabs8_1Y1mvX9Kz3teR_45CIAgPiDzGQfDNADVGhneJ0zdEukMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/community-tabs.vue?macro=true";
import { default as reported_45content04gCGW2cp0VC_45uV_45xBVqOEBc5u_45ZQgXayzMpfXcY5DcMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/reported-content.vue?macro=true";
import { default as promotional_45linkss_xwSAKxXlabd085SSJ7ts59FGYzLX1OwOCJsdrPvQMMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/promotional-links.vue?macro=true";
import { default as gamification_45rewardsBXSLgH6jHacF5wt5bm2ooHK_d8lPeymGgSiG7FYDMwEMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/gamification-rewards.vue?macro=true";
import { default as membership_45questionsHcnUwRgOKrHJ8BxlV9A6_L5A4xgPEk66LmwbWYANuqcMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/membership-questions.vue?macro=true";
import { default as _91lessonId_93_45pAVP5I2l_5_45c_Ksvy8ZyuBLbCwTtrHXoewXCDV_jYkMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/courses/routing-layer/pages/courses/products/[productId]/modules/[moduleId]/lessons/[lessonId].vue?macro=true";
import { default as _91lessonId_93OADe8s63RMUrAnn7fZogaZaqXlXOPvHPVP7trkgiJtYMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/courses/routing-layer/pages/courses/products/[productId]/modules/[moduleId]/lessons/new/[lessonId].vue?macro=true";
import { default as purchaseMAN5EAk2Yc4N2bawHIFByER_45RJ3FSlns5zqjyCiBY7YMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/learning/courses/products/[productId]/purchase.vue?macro=true";
import { default as _91lessonId_93v9TYmWvzdG7WhieepzQi_ep3yDPFH_4584cDZiy3h8NKEMeta } from "/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/learning/courses/products/[productId]/modules/[moduleId]/lessons/[lessonId].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: {"cpRoute":true,"middleware":["redirect-clientportal-default-landing"]},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/index.vue")
  },
  {
    name: "account",
    path: "/account",
    meta: { ...(account3HufUZFYdCCy3y1_InwrtoWh727HuMTu7HOGCTubAD8Meta || {}), ...{"middleware":[]} },
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/account-settings/common-layer/pages/account.vue")
  },
  {
    name: "auth",
    path: "/auth",
    meta: { ...(indexrSwjwFmUsdCHgq7ejOBbgACeD4cTKyTLEWhF6MPkjMUMeta || {}), ...{"cpRoute":true} },
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/auth/index.vue")
  },
  {
    name: "auth-login",
    path: "/login",
    meta: { ...(loginBipPEegN8gfngljKdMa_451_zrD7mzapKN4YoHIV5dfHMMeta || {}), ...{"cpRoute":true} },
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/auth/login.vue")
  },
  {
    name: "auth-signup",
    path: "/signup",
    meta: { ...(signup_50uaXaQ9efyfsK_45TzxZxbBq4RyDjWHWJ2OKOsPbkbwMeta || {}), ...{"cpRoute":true} },
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/auth/signup.vue")
  },
  {
    name: "notFound",
    path: "/:notFound(.*)*",
    meta: {"cpRoute":true,"middleware":["redirect-clientportal-default-landing"]},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/[...notFound].vue")
  },
  {
    name: "courses",
    path: "/courses",
    meta: {"cpRoute":true},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/courses/index.vue")
  },
  {
    name: "courses-search",
    path: "/courses/search",
    meta: searchU9a9DSKELD4AC2BEi5jWWveJpmxViXXk09N2UcC3Vy0Meta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/courses/routing-layer/pages/courses/search.vue")
  },
  {
    name: "invoices",
    path: "/invoices",
    meta: {"cpRoute":true},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/invoices/index.vue")
  },
  {
    name: "affiliates-lead",
    path: "/affiliates/lead",
    meta: { ...(leadxnbs9cWCdRZ_45ZJqWZRrHm0WlNctuFEQZn5UXm0uzxMAMeta || {}), ...{"cpRoute":true} },
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/affiliates/lead.vue")
  },
  {
    name: "contracts",
    path: "/contracts",
    meta: {"cpRoute":true},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/contracts/index.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: {"cpRoute":true},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/dashboard/index.vue")
  },
  {
    name: "documents",
    path: "/documents",
    meta: {"cpRoute":true},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/documents/index.vue")
  },
  {
    name: "estimates",
    path: "/estimates",
    meta: {"cpRoute":true},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/estimates/index.vue")
  },
  {
    name: "affiliates",
    path: "/affiliates",
    meta: { ...(index8_45sXo8kiVYwmbQ9Gv0Of7B_cpMN0noYitwnBgfang8oMeta || {}), ...{"cpRoute":true} },
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/affiliates/index.vue")
  },
  {
    name: "courses-discover",
    path: "/courses/discover",
    meta: {"cpRoute":true},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/courses/discover.vue")
  },
  {
    name: "communities",
    path: "/communities",
    meta: {"cpRoute":true},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/communities/index.vue")
  },
  {
    name: "appointments",
    path: "/appointments",
    meta: {"cpRoute":true},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/appointments/index.vue")
  },
  {
    name: "courses-my-courses",
    path: "/courses/my-courses",
    meta: {"cpRoute":true},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/courses/my-courses.vue")
  },
  {
    name: "courses-my-library",
    path: "/courses/my-library",
    meta: my_45libraryx3OOe6GLkKnhwQWP59h8y2n6npIgYr1cTahOevFAm04Meta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/courses/routing-layer/pages/courses/my-library.vue")
  },
  {
    name: "shared-files",
    path: "/shared-files",
    meta: {"cpRoute":true},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/shared-files/index.vue")
  },
  {
    name: "affiliates-campaign",
    path: "/affiliates/campaign",
    meta: { ...(campaigngdFhhIBQoDRs9JBEIKS2K7hRGam8_mhFYyujJ_evGdUMeta || {}), ...{"cpRoute":true} },
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/affiliates/campaign.vue")
  },
  {
    name: "auth-reset-password",
    path: "/reset-password",
    meta: { ...(reset_45password5y14axdvWv_dplDeVyOGaZ_rbiVm6_xtX23dS4A4WP0Meta || {}), ...{"cpRoute":true} },
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/auth/reset-password.vue")
  },
  {
    name: "courses-checkout",
    path: "/courses/:productId()",
    meta: _91productId_93u35MLwMZSrD8Cu_45mFLZt_L94iAVANvZ7tLjbrFIZ3PIMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/courses/routing-layer/pages/courses/[productId].vue")
  },
  {
    name: "auth-forgot-password",
    path: "/forgot-password",
    meta: { ...(forgot_45passwordtIMvS_45KvqX4QzB1xXRz6WOw7G9dM172GInQcEQ_455trAMeta || {}), ...{"cpRoute":true} },
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/auth/forgot-password.vue")
  },
  {
    name: "auth-login-with-code",
    path: "/login-with-code",
    meta: { ...(login_45with_45codeGKBcsdjY4zWLoo1LcdJhxDN3259fmpJFfByFjzlk_uQMeta || {}), ...{"cpRoute":true} },
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/auth/login-with-code.vue")
  },
  {
    name: "communities-discover",
    path: "/communities/discover",
    meta: {"cpRoute":true},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/communities/discover.vue")
  },
  {
    name: "affiliates-commission",
    path: "/affiliates/commission",
    meta: { ...(commissionff57G1xL7vJBnLB4NRRzF0B1iAb_457uzyU7ON_45KBFyGQMeta || {}), ...{"cpRoute":true} },
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/affiliates/commission.vue")
  },
  {
    name: "auth-expired-password",
    path: "/expired-password",
    meta: { ...(expired_45password9_45CEtO70kh1zxmtCac3FigMGcaNh6zb4cj9yV5bAYa4Meta || {}), ...{"cpRoute":true} },
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/auth/expired-password.vue")
  },
  {
    name: "affiliates-media",
    path: "/affiliates/media",
    meta: { ...(indexYzyzzi1w9qvZ3_w0t7Ggolq33eZzmbSPtXjqAymGyPIMeta || {}), ...{"cpRoute":true} },
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/affiliates/media/index.vue")
  },
  {
    name: "affiliates-sub-affiliate",
    path: "/affiliates/sub-affiliate",
    meta: { ...(sub_45affiliatetU3xK5g4Id8lM603d7tnZ_hfNQHdHMlFsFDU6ijck_IMeta || {}), ...{"cpRoute":true} },
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/affiliates/sub-affiliate.vue")
  },
  {
    name: "affiliates-payout-methods",
    path: "/affiliates/payout-methods",
    meta: { ...(payout_45methodsdndl_J0jnwaMFmdP0mZppoIMJWtxP5YO5gEDd8fch1YMeta || {}), ...{"cpRoute":true} },
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/affiliates/payout-methods.vue")
  },
  {
    name: "auth-profile-confirmation",
    path: "/profile-confirmation",
    meta: { ...(profile_45confirmation4m_krel8AaTUjKBFZdYMMf_QfItcUNv56bsngZBYHXoMeta || {}), ...{"cpRoute":true} },
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/auth/profile-confirmation.vue")
  },
  {
    name: "communities-my-communities",
    path: "/communities/my-communities",
    meta: {"cpRoute":true},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/communities/my-communities.vue")
  },
  {
    name: "communities-groups-not-found",
    path: "/communities/groups/not-found",
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/not-found.vue")
  },
  {
    name: "communities-conversations",
    path: "/communities/conversations",
    meta: indexaQWfUXk1awq_9AYxeD7K49V27LcDIW8ccws2tjJd1rIMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/conversations/index.vue")
  },
  {
    name: "courses-bundles-bundleOfferId",
    path: "/courses/bundles/:bundleOfferId()",
    meta: {"cpRoute":true},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/courses/bundles/[bundleOfferId].vue")
  },
  {
    name: "courses-products-new-productId",
    path: "/courses/products/new/:productId()",
    meta: _91productId_93TPFyk8N4jdRZjTI6CwI4ohoao7ZoHMExep_45u4rZHOPQMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/courses/routing-layer/pages/courses/products/new/[productId].vue")
  },
  {
    name: "affiliates-media-folder-folderId",
    path: "/affiliates/media/folder/:folderId()",
    meta: { ...(_91folderId_93uhOavHrWnxM1T0tFfzIOa_45CLFlrznzqq56u8yzp_45wmkMeta || {}), ...{"cpRoute":true} },
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/affiliates/media/folder/[folderId].vue")
  },
  {
    name: "communities-users-userSlug",
    path: "/communities/users/:userSlug()",
    meta: indexKYH51dinf_45mDCIEQc8KWeefcdEqtsnO_45_45pzut1T90rcMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/users/[userSlug]/index.vue")
  },
  {
    name: "courses-products-productId",
    path: "/courses/products/:productId()",
    meta: indexE64TAFFH_45kPa84I7bVgUn8O5yaa6Fxxa3eQs0JQLhIEMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/courses/routing-layer/pages/courses/products/[productId]/index.vue")
  },
  {
    name: "communities-groups-groupSlug-home",
    path: "/communities/groups/:groupSlug()/home",
    meta: home2VHrIbY_yhHS018exrqpuaurDfMeGJaNwvmJ96mrlTQMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/home.vue"),
    children: [
  {
    name: "communities-groups-groupSlug-home-posts-postId",
    path: "posts/:postId()",
    meta: _91postId_93seI0_pf4xTKQmgzX4yesH0VGXc97rqHBC4vIJeiDWb0Meta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/home/posts/[postId].vue")
  }
]
  },
  {
    name: "communities-groups-groupSlug-about",
    path: "/communities/groups/:groupSlug()/about",
    meta: aboutgxoGMm4FGzqRVJczc1fx29mDUaFAaTETxT7HNxT3DCAMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/about.vue")
  },
  {
    name: "communities-groups-groupSlug",
    path: "/communities/groups/:groupSlug()",
    meta: indexrzzRMGJDAe2ZRHKXPABO2NsES4_4573P6Ryjejs45aABgMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/index.vue")
  },
  {
    name: "affiliates-affiliatesIndexPage.middleware",
    path: "/affiliates/affiliatesIndexPage.middleware",
    meta: {"cpRoute":true},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/clientportal/routing-layer/pages/affiliates/affiliatesIndexPage.middleware.ts")
  },
  {
    name: "communities-users-userSlug-communities",
    path: "/communities/users/:userSlug()/communities",
    meta: communitiesSblnqHPFKvRZjxK8DqKRLKt_YvlGgNAe_45zsSJNQ0LrUMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/users/[userSlug]/communities.vue")
  },
  {
    name: "communities-conversations-conversationId",
    path: "/communities/conversations/:conversationId()",
    meta: _91conversationId_93ol3zaKSLqWkCdSTec0GAaZZUmBmG14s7z92vIKYnrakMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/conversations/[conversationId].vue")
  },
  {
    name: "communities-groups-groupSlug-leaderboard",
    path: "/communities/groups/:groupSlug()/leaderboard",
    meta: leaderboardSJiSW5feL7FvqZeQ7ihc4rjOkFo0Ymv1i4cdbLZrmvEMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/leaderboard.vue")
  },
  {
    name: "communities-users-userSlug-contributions",
    path: "/communities/users/:userSlug()/contributions",
    meta: contributionsACrgBfQ49pWdeU_Xh12X2lSEPW5ZgE2kDlDc0ighoHoMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/users/[userSlug]/contributions.vue")
  },
  {
    name: "courses-products-productId-live-sessions",
    path: "/courses/products/:productId()/live-sessions",
    meta: live_45sessionsdPG82oHl2HCovO33pB7pLTWGJLnXSzPAgrX3CXjiivsMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/courses/routing-layer/pages/courses/products/[productId]/live-sessions.vue")
  },
  {
    name: "communities-groups-groupSlug-events",
    path: "/communities/groups/:groupSlug()/events",
    meta: indexy9aEAnIxfkBm3kXMZC48C8oKkAqcc1E21YyEOlDe8z4Meta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/events/index.vue")
  },
  {
    name: "communities-users-userSlug-posts-postId",
    path: "/communities/users/:userSlug()/posts/:postId()",
    meta: _91postId_93D2XYPbNGtVcvDMue_45BEGHVaE1zrY7AnG7jSIko6u1hoMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/users/[userSlug]/posts/[postId].vue")
  },
  {
    name: "communities-groups-groupSlug-catchAll",
    path: "/communities/groups/:groupSlug()/:catchAll(.*)*",
    meta: _91_46_46_46catchAll_93fACdXHgsApX1eM8KUj1aF_4N0MJe2OsOLziPYnbYehAMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/[...catchAll].vue")
  },
  {
    name: "communities-groups-groupSlug-conversations",
    path: "/communities/groups/:groupSlug()/conversations",
    meta: conversationsFH3LUtF5A_45ywkmqT57gcMpvjyiyqB93q7SlFiZ_bB0kMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/conversations.vue")
  },
  {
    name: "communities-groups-groupSlug-members",
    path: "/communities/groups/:groupSlug()/members",
    meta: indexIBHs_9q3VRpfpbMz3NjKKdZGseQqx_450rwb8ArmAtAdAMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/members/index.vue")
  },
  {
    name: "courses-products-productId-purchase-course",
    path: "/courses/products/:productId()/purchase-course",
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/courses/routing-layer/pages/courses/products/[productId]/purchase-course.vue")
  },
  {
    name: "communities-groups-groupSlug-learning",
    path: "/communities/groups/:groupSlug()/learning",
    meta: index4MWqiAvCaWRE5fZBduDawDM4ZIpYay9Jcy8hNNiAbwQMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/learning/index.vue")
  },
  {
    name: "communities-groups-groupSlug-settings",
    path: "/communities/groups/:groupSlug()/settings",
    meta: indexkWa3GOh33J_5vxZhQpZrphHNHBER0w_45c_45A8U6HOlL6EMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/index.vue")
  },
  {
    name: "communities-groups-groupSlug-settings-details",
    path: "/communities/groups/:groupSlug()/settings/details",
    meta: detailscKT9p2PBxpE_5cQHeTIp26vBofL5nhsGWxcVzJaMr9wMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/details.vue")
  },
  {
    name: "communities-groups-groupSlug-settings-branding",
    path: "/communities/groups/:groupSlug()/settings/branding",
    meta: brandingFJhOl97O9T3c1B0_RRuk1AZIZtNYQ5P5b6LIXo0s4XoMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/branding.vue")
  },
  {
    name: "communities-groups-groupSlug-settings-discovery",
    path: "/communities/groups/:groupSlug()/settings/discovery",
    meta: discoveryvH_1fE2SFBjyb5FmNixzO_45N_w92kAGDYn_VzivQz4EMMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/discovery.vue")
  },
  {
    name: "communities-groups-groupSlug-settings-appearance",
    path: "/communities/groups/:groupSlug()/settings/appearance",
    meta: appearancegddrWvWP7HTdLEiClbAZN_45XQ9jOrZjTLZDfod93jT_45kMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/appearance.vue")
  },
  {
    name: "communities-groups-groupSlug-settings-newsletter",
    path: "/communities/groups/:groupSlug()/settings/newsletter",
    meta: newsletterpXgw_Jqrpzw_RsZZoQvbOU65u_aT146jWmQzYBnVStEMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/newsletter.vue")
  },
  {
    name: "communities-groups-groupSlug-channels-channelSlug",
    path: "/communities/groups/:groupSlug()/channels/:channelSlug()",
    meta: _91channelSlug_93gM6CK4vY0aHyNA4YQdieZkXaZL_45PJFGY18CkYbFxSbEMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/channels/[channelSlug].vue"),
    children: [
  {
    name: "communities-groups-groupSlug-channels-channelSlug-posts-postId",
    path: "posts/:postId()",
    meta: _91postId_93ExW0TNM8vBx5NBoWIEQJWUnu9ZwLXBSfF7z5N3Zs6f0Meta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/channels/[channelSlug]/posts/[postId].vue")
  }
]
  },
  {
    name: "communities-groups-groupSlug-settings-subscriptions",
    path: "/communities/groups/:groupSlug()/settings/subscriptions",
    meta: subscriptionszLSQyvoRgth86tmtTCSp1v01sO5Vo5pbb91c74t3IekMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/subscriptions.vue")
  },
  {
    name: "communities-groups-groupSlug-settings-community-tabs",
    path: "/communities/groups/:groupSlug()/settings/community-tabs",
    meta: community_45tabs8_1Y1mvX9Kz3teR_45CIAgPiDzGQfDNADVGhneJ0zdEukMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/community-tabs.vue")
  },
  {
    name: "communities-groups-groupSlug-settings-reported-content",
    path: "/communities/groups/:groupSlug()/settings/reported-content",
    meta: reported_45content04gCGW2cp0VC_45uV_45xBVqOEBc5u_45ZQgXayzMpfXcY5DcMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/reported-content.vue")
  },
  {
    name: "communities-groups-groupSlug-settings-promotional-links",
    path: "/communities/groups/:groupSlug()/settings/promotional-links",
    meta: promotional_45linkss_xwSAKxXlabd085SSJ7ts59FGYzLX1OwOCJsdrPvQMMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/promotional-links.vue")
  },
  {
    name: "communities-groups-groupSlug-settings-gamification-rewards",
    path: "/communities/groups/:groupSlug()/settings/gamification-rewards",
    meta: gamification_45rewardsBXSLgH6jHacF5wt5bm2ooHK_d8lPeymGgSiG7FYDMwEMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/gamification-rewards.vue")
  },
  {
    name: "communities-groups-groupSlug-settings-membership-questions",
    path: "/communities/groups/:groupSlug()/settings/membership-questions",
    meta: membership_45questionsHcnUwRgOKrHJ8BxlV9A6_L5A4xgPEk66LmwbWYANuqcMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/membership-questions.vue")
  },
  {
    name: "courses-products-productId-modules-moduleId-lessons-lessonId",
    path: "/courses/products/:productId()/modules/:moduleId()/lessons/:lessonId()",
    meta: _91lessonId_93_45pAVP5I2l_5_45c_Ksvy8ZyuBLbCwTtrHXoewXCDV_jYkMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/courses/routing-layer/pages/courses/products/[productId]/modules/[moduleId]/lessons/[lessonId].vue")
  },
  {
    name: "courses-products-productId-modules-moduleId-lessons-new-lessonId",
    path: "/courses/products/:productId()/modules/:moduleId()/lessons/new/:lessonId()",
    meta: _91lessonId_93OADe8s63RMUrAnn7fZogaZaqXlXOPvHPVP7trkgiJtYMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/courses/routing-layer/pages/courses/products/[productId]/modules/[moduleId]/lessons/new/[lessonId].vue")
  },
  {
    name: "courses-purchase-product",
    path: "/communities/groups/:groupSlug()/learning/courses/products/:productId()/purchase",
    meta: purchaseMAN5EAk2Yc4N2bawHIFByER_45RJ3FSlns5zqjyCiBY7YMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/learning/courses/products/[productId]/purchase.vue")
  },
  {
    name: "communities-groups-groupSlug-learning-courses-products-productId-modules-moduleId-lessons-lessonId",
    path: "/communities/groups/:groupSlug()/learning/courses/products/:productId()/modules/:moduleId()/lessons/:lessonId()",
    meta: _91lessonId_93v9TYmWvzdG7WhieepzQi_ep3yDPFH_4584cDZiy3h8NKEMeta || {},
    component: () => import("/tmp/workspace/staging/revex/memberships-preview/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/learning/courses/products/[productId]/modules/[moduleId]/lessons/[lessonId].vue")
  }
]